import React from "react";
import { Button, TextInput, Tooltip } from "carbon-components-react";
import { Edit20 } from "@carbon/icons-react";

interface Props {
  fieldName: string;
  formValue: any;
  onChange: any;
  onSave: any;
  onClear: any;
  labelText: string;
  inputType: string;
}

const TooltipForm: React.FC<Props> = ({
  formValue,
  fieldName,
  onChange,
  onSave,
  onClear,
  labelText,
  inputType,
}: Props) => {
  return (
    <Tooltip direction="right" tabIndex={0} renderIcon={Edit20}>
      {labelText && <p>{labelText}</p>}
      <TextInput
        labelText=""
        id={fieldName}
        name={fieldName}
        value={formValue}
        type={inputType}
        onChange={e => onChange(e)}
        onBlur={e => onChange(e)}
        size="sm"
      />
      <Button size="field" onClick={() => onSave()}>
        Save
      </Button>
      <Button size="field" kind="secondary" onClick={() => onClear()}>
        Remove override
      </Button>
    </Tooltip>
  );
};

export default TooltipForm;
